import React from "react";
import BeneficariesView from "../BeneficariesView/BeneficariesView";
import Icon1 from "../../images/gbrFarmerBenefits/pay-per-click.svg";
// Main component for Plant Executive Role
const PlantExecutive = () => {
  // Features that highlight the key functionalities for a Plant Executive
  const features = [
    {
      image: Icon1,
      title: "Real-Time Production Monitoring",
      bodycopy:
        "Live tracking of production metrics, machine status, and workforce efficiency.",
    },
    {
      image: Icon1,
      title: "Batch & Inventory Management",
      bodycopy:
        "End-to-end tracking of raw materials, WIP (Work in Progress), and finished goods.",
    },
    {
      image: Icon1,
      title: "Supplier & Buyer Integration",
      bodycopy:
        "Seamless connection with raw material suppliers and B2B/B2C buyers.",
    },
  ];

  // Benefits of the Plant Executive role
  const benefits = [
    {
      image: Icon1,
      title: "Improved Operational Efficiency",
      bodycopy:
        "Reduces downtime and optimizes workflow for higher productivity.",
    },
    {
      image: Icon1,
      title: "Faster Decision-Making",
      bodycopy:
        "Access to real-time analytics helps in quick problem resolution.",
    },
    {
      image: Icon1,
      title: "Supply Chain Stability",
      bodycopy:
        "Stronger coordination with suppliers and buyers reduces disruptions.",
    },
  ];

  return (
    <>
      {/* Displays the banner, features and benefits of the Plant Executive role */}
      <BeneficariesView title="Plant Executive" features={features} benefits={benefits} />
    </>
  );
};

export default PlantExecutive;

